import { render, staticRenderFns } from "./BasicFilters.vue?vue&type=template&id=0d00e64f&scoped=true&"
import script from "./BasicFilters.vue?vue&type=script&lang=js&"
export * from "./BasicFilters.vue?vue&type=script&lang=js&"
import style0 from "./BasicFilters.vue?vue&type=style&index=0&id=0d00e64f&prod&lang=css&"
import style1 from "./BasicFilters.vue?vue&type=style&index=1&id=0d00e64f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d00e64f",
  null
  
)

export default component.exports